import React, { Component } from 'react'
import { TableRow, MenuItem, Button, TableCell, Chip, Input } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'
import {
  TableCellWithTextField,
  TableCellWithSwitch,
  TableCellWithSelect,
} from '../../../components/common/PureItems'

import EditActionComponent from '../../../components/common/EditActionComponent'
import _ from 'lodash'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export default class ActivityTypeListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isUpdateCompleted !== prevProps.isUpdateCompleted &&
      this.props.isUpdateCompleted === true
    ) {
      this.props.disableEdit()
    }
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode, categoryList } = this.props
    const categoryNameList = _.map(data.categories, (i) => {
      const cat = _.find(categoryList, (j) => j.id === i)
      return cat ? cat.name : ''
    })

    return (
      <TableRow>
        <TableCellWithTextField
          valueToRender={data.name}
          editMode={editMode}
          value={data.name}
          onChange={this.onChange('name')}
          type="text"
          inputProps={{
            maxLength: 50,
          }}
        />
        <TableCellWithTextField
          valueToRender={data.description}
          editMode={editMode}
          value={data.description}
          onChange={this.onChange('description')}
          type="text"
          inputProps={{
            maxLength: 50,
          }}
        />
        <TableCellWithSelect
          valueToRender={categoryNameList.join()}
          value={data.categories}
          editMode={editMode}
          name="categories"
          onChange={this.onChange('categories')}
          multiple
          input={<Input id="select-multiple-chip" />}
          renderValue={(selected) => (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {selected.map((value) => {
                const item = _.find(this.props.categoryList, (i) => i.id === value)
                return <Chip key={value} label={item ? item.name : ''} style={{ margin: 2 }} />
              })}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {categoryList && categoryList.map((i) => <MenuItem value={i.id}>{i.name}</MenuItem>)}
        </TableCellWithSelect>
        <TableCellWithSwitch
          valueToRender={data.active ? 'Active' : 'Inactive'}
          checked={data.active}
          editMode={editMode}
          onChange={this.onChange('active', true)}
        />
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/ActivityTypeListItem.js